import type { GetStaticProps } from 'next';
import {
  fetchBlogPosts,
  fetchCaseStudies,
} from '../../utils/api/fetchStrapiData';
import { formatFilterNameToValue } from '../../views/caseStudies/CaseStudies.utils';
import { ZeroKnowledgeProofDevelopmentPage } from '../../views/zeroKnowledgeProofDevelopmentPage/zeroKnowledgeProofDevelopmentPage';

export const getStaticProps: GetStaticProps = async () => {
  const [blogPosts, allCaseStudies] = await Promise.all([
    fetchBlogPosts(),
    fetchCaseStudies(),
  ]);

  const caseStudies = allCaseStudies
    .filter((cs) =>
      cs.case_study_services.some(
        (service) =>
          service?.name &&
          formatFilterNameToValue(service.name) ===
            'zero-knowledge-proof-development'
      )
    )
    .slice(0, 3);

  return {
    props: { blogPosts, caseStudies },
  };
};

export default ZeroKnowledgeProofDevelopmentPage;
